/* Bouton reconnexion Shopify dans Paramètres */
(function(){
  "use strict";

  const SHOPIFY_AUTH_URL = "https://bubbly-vibrancy-production.up.railway.app/auth/start";

  function inject(){
    const settings = document.getElementById("mtsPanelSettings");
    if(!settings || document.getElementById("mtsReconnectShopify")) return;

    const list = settings.querySelector(".mts-settings-list");
    if(!list) return;

    const row = document.createElement("div");
    row.innerHTML = `
      <strong>Shopify</strong>
      <span>
        Connexion Railway / Shopify<br>
        <a id="mtsReconnectShopify"
           class="mts-btn mts-ok"
           href="${SHOPIFY_AUTH_URL}"
           target="_blank"
           rel="noopener"
           style="display:inline-flex;margin-top:10px;text-decoration:none;">
          🔗 Reconnecter Shopify
        </a>
      </span>
    `;

    list.appendChild(row);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", inject);
  }else{
    inject();
  }

  setInterval(inject, 1500);
})();